import { useMutation } from "./urqlHooks";

const CREATE_EMAIL = `mutation CREATE_EMAIL($input: EmailInput!){
    createEmail(input: $input) {
        id
    }
}`;

export const CreateEmail = () => {
    const [result, executeMutation] = useMutation(CREATE_EMAIL)
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation }
};

const UPDATE_EMAIL = `mutation UPDATE_EMAIL($input: EmailInput!){
    updateEmail(input: $input) {
        id
    }
}`;

export const UpdateEmail = () => {
    const [result, executeMutation] = useMutation(UPDATE_EMAIL)
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation }
};
const SEND_NOTE_NOTIFICATION_EMAIL = `
  mutation sendNoteNotificationEmail($noteEmailInput: NoteEmailInput!) {
    sendNoteNotificationEmail(noteEmailInput: $noteEmailInput)
  }
`;

export const SendNoteNotificationEmail = () => {
  const [result, executeMutation] = useMutation(SEND_NOTE_NOTIFICATION_EMAIL);
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};
